var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'uuid/v4'. '/Users/dkrajnak/workspace/aviso/sse-frontend/react/node_modules/uuid/v4.js' implicitly has an 'any' type.
import uuid from "uuid/v4";
import { useFormContext } from "react-hook-form";
import SearchField from "../../../Form/SearchField";
import PersonService from "../../../../Services/Person.service";
import { OpportunityAssigneeMultiSearch } from "../../Opportunity/OpportunityAssigneeSearch";
import ValidationService from "../../../../Services/Shared/Validation.service";
export const RANDOM_ASSIGNEE_POOL_MAX_AMOUNT = 20;
export const CHANGE_ASSIGNEE_GET_CRITERIA = (formState, { exportNodeId, pipelineId }) => {
    var _a, _b;
    const OPPORTUNITY_LOADER_DELEGATE_ID = uuid();
    const opportunityLoaderDelegate = {
        id: OPPORTUNITY_LOADER_DELEGATE_ID,
        type: "OpportunityLoader",
        criteria: {
            subjectId: {
                isReference: true,
                workflowNodeReferenceId: exportNodeId,
                propertyName: "studentId",
            },
            pipelineId: {
                isReference: false,
                value: pipelineId,
            },
        },
    };
    return {
        delegates: [opportunityLoaderDelegate],
        criteria: {
            opportunityId: {
                isReference: true,
                propertyName: "opportunityId",
                workflowNodeReferenceId: OPPORTUNITY_LOADER_DELEGATE_ID,
            },
            assigneeIds: {
                value: (_b = (_a = formState.assignees) === null || _a === void 0 ? void 0 : _a.map((data) => data.personId)) !== null && _b !== void 0 ? _b : undefined,
                isReference: false,
            },
            pipelineId: {
                value: pipelineId,
                isReference: false,
            },
        },
    };
};
export const CHANGE_ASSIGNEE_GET_FORM_STATE = (criteria) => __awaiter(void 0, void 0, void 0, function* () {
    const assignees = yield PersonService.getPeopleByPersonId(criteria.assigneeIds.value);
    return { assignees };
});
const ChangeAssigneeWorkflowNodeDefinitionForm = ({ name, pipelineId, }) => {
    const { errors, watch } = useFormContext();
    const selectedAssignees = watch(name + ".assignees");
    return (_jsx(_Fragment, { children: _jsx(SearchField, { name: name + ".assignees", label: "Assignee(s)", required: true, multiRequiredFix: true, maxSelectedItems: RANDOM_ASSIGNEE_POOL_MAX_AMOUNT, as: (provided) => (_jsx(OpportunityAssigneeMultiSearch, Object.assign({}, provided, { pipelineId: pipelineId, "aria-label": "Assignee(s)", className: ValidationService.makeClassName(errors, "assignees"), lookupModal: {
                    isInModal: false,
                    pipelineId,
                    // @ts-expect-error - TS2322 - Type '{ isInModal: false; pipelineId: number; selected: any; }' is not assignable to type 'WithLookupModal<OpportunityAssigneeLookupModalProps>'.
                    selected: selectedAssignees,
                }, noOptionsMessage: ({ inputValue }) => {
                    if ((inputValue === null || inputValue === void 0 ? void 0 : inputValue.length) < 3) {
                        return "Please type at least 3 characters";
                    }
                    return "No Options";
                }, minNumSearchCharacters: 3 }))), helpText: "If multiple assignees are selected, a random one among them will be selected every time this automation occurs and then assigned to the opportunity. Up to a maximum of 20 assignees can be selected." }) }));
};
export default ChangeAssigneeWorkflowNodeDefinitionForm;
